import { type DropdownItemProps } from "semantic-ui-react";

export const renderCustomLabel = (item: DropdownItemProps) => {
  return { content: item.text, removeIcon: item.disabled ? null : "delete" };
};
